module.exports = __webpack_public_path__ + "static/img/atm-step-3.a1ff2e8e.png";